import React, { useEffect, useState } from 'react';

import CustomDropdown from '@components/CustomDropdown';
import LoaderComponent from '@components/LoaderComponent';
import { toastError, toastSuccess } from '@components/Toast';

import AddNewSalesContractModal from '@features/order/components/commercial-invoice/AddNewSalesContractModal';

import {
	fetchAllAmendments,
	onAddNewAmendment,
	onUpdateContructDetails,
	searchSalesContructs
} from '@services/salesContructService';

import ApiClient from '@lib/apiClient';

import { checkAnyUserType } from '@utils/Util';

const EditSalesContruct = ({ setIsEditSalesContruct, onSalesContractDetailsInfo, salesContractDetails }) => {
	const [salesContructInfo, setSalesContructInfo] = useState({
		id: salesContractDetails?.salesContractId || '',
		contractNo: salesContractDetails?.contractNo || '',
		contractDate: salesContractDetails?.contractDate || '',
		value: salesContractDetails?.contractNo || ''
	});
	const [amendment, setAmendment] = useState({
		salesContractId: salesContractDetails?.salesContractId || '',
		amendmentId: salesContractDetails?.amendmentId || '',
		amendmentNo: salesContractDetails?.amendmentNo || '',
		amendmentDate: salesContractDetails?.amendmentDate || ''
	});
	const [salesContructList, setSalesContructList] = useState([]);
	const [amendmentList, setAmendmentList] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [disabledAmendment, setDisabledAmendment] = useState(false);
	const [, setDisabledScDate] = useState(true);
	const [showNewSalesContractModal, setShowNewSalesContractModal] = useState(false);
	const [isAdmin, setIsAdmin] = useState(false);
	const [salesContructSearchValue, setSalesContructSearchValue] = useState('');
	const [isExistItemError] = useState(false);

	const getAllSalesContructs = async () => {
		const data = await searchSalesContructs(`?supplierId=${salesContractDetails?.supplierId}&search`);
		setSalesContructList(data);
	};

	const getAllAmendments = async () => {
		const data = await fetchAllAmendments(salesContructInfo?.id);
		setAmendmentList(data);
	};

	useEffect(() => {
		getAllSalesContructs();
		if (salesContructInfo?.id) getAllAmendments();
	}, [salesContructInfo?.id]);

	useEffect(() => {
		const checkUserType = checkAnyUserType(['ADMIN']);
		setIsAdmin(checkUserType);
	}, []);

	const onCreateNewSalesContract = async (
		setIsOpen,
		setDisabledScDate,
		setDisabledAmendment,
		salesContractValue,
		setErrorState
	) => {
		const body = salesContractValue ? salesContractValue : {};
		const param = salesContractValue
			? `/${salesContractDetails?.supplierId}?newContractNo=${salesContractValue}`
			: `/${salesContractDetails?.supplierId}`;
		ApiClient.POST('createSalesContruct', body, param)
			.then(({ data }) => {
				toastSuccess('New sales contruct created.');
				setSalesContructList((prev) => [...prev, { ...data, value: data?.contractNo }]);
				setSalesContructInfo({ ...data, value: data?.contractNo });
				setAmendment({
					salesContractId: '',
					amendmentId: '',
					amendmentNo: '',
					amendmentDate: ''
				});
				if (setIsOpen && setDisabledScDate && setDisabledAmendment) {
					setIsOpen(false);
					setDisabledScDate(false);
					setDisabledAmendment(true);
				}
				setErrorState(false);
			})
			.catch((error) => {
				if (error && error.response.data && error.response.data.message) {
					toastError(error.response.data.message);
					setErrorState(true);
				}
			});
	};

	const createSalesContruct = async (_search, setIsOpen) => {
		await onCreateNewSalesContract(setIsOpen, setDisabledScDate, setDisabledAmendment);
	};

	const createNewAmendment = async (_search, setIsOpen) => {
		try {
			const data = await onAddNewAmendment(salesContructInfo?.id, setIsLoading);
			if (data) {
				setAmendment({ ...data, value: data?.amendmentNo });
			}
			setAmendmentList((prev) => [...prev, { ...data, value: data?.amendmentNo }]);
			setIsOpen(false);
		} catch (response) {
			if (response && response.data && response.data.message) {
				toastError(response.data.message);
			}
		}
	};

	const updateContructDetails = async () => {
		const requestBody = {
			salesContractId: salesContructInfo?.id || null,
			amendmentId: amendment?.amendmentId || null,
			contractDate: salesContructInfo?.contractDate || null,
			amendmentDate: amendment?.amendmentDate || null
		};
		await onUpdateContructDetails(requestBody, salesContractDetails?.id, setIsLoading);
		setIsEditSalesContruct(false);
		onSalesContractDetailsInfo(salesContractDetails?.id);
	};

	const onAddNewSalesContract = (searchKey) => {
		setSalesContructSearchValue(searchKey);
		setShowNewSalesContractModal(true);
	};

	return (
		<LoaderComponent loading={isLoading}>
			<div className="container px-0">
				<div className="row">
					<div className="col-md-12">
						<div className="d-flex justify-content-end mb-2">
							<span
								className="regular-14 primary_bright_01 cursor-pointer"
								onClick={updateContructDetails}
							>
								Update
							</span>
							<span
								onClick={() => setIsEditSalesContruct(false)}
								className="regular-14 red cursor-pointer pl-2"
							>
								Cancel
							</span>
						</div>
					</div>
					<div className="col-md-6 pr-6">
						<div className="form-group">
							<label htmlFor="salesContructNo">Sales Contract No</label>
							<CustomDropdown
								items={salesContructList}
								onItemClick={(item) => {
									setSalesContructInfo(item);
									setDisabledAmendment(false);
									setAmendment({
										salesContractId: '',
										amendmentId: '',
										amendmentNo: '',
										amendmentDate: ''
									});
								}}
								selectedItem={salesContructInfo?.contractNo}
								showAddNewButton={isAdmin}
								addNewButtonName="New Sales Contract"
								onGenerateNumberButton={createSalesContruct}
								onAddNewButtonClick={onAddNewSalesContract}
							/>
						</div>
						{showNewSalesContractModal && (
							<AddNewSalesContractModal
								setShowAddNewSalesContract={setShowNewSalesContractModal}
								onSubmitNewSalesContract={onCreateNewSalesContract}
								salesContructSearchValue={salesContructSearchValue}
								isExistItemError={isExistItemError}
							/>
						)}
					</div>

					<div className="col-md-6 pl-6">
						<div className="form-group">
							<label htmlFor="salesContructDate">Sales Contract Date</label>
							<input
								type="date"
								value={salesContructInfo?.contractDate}
								// disabled={disabledScDate}
								onChange={(e) =>
									setSalesContructInfo({
										...salesContructInfo,
										contractDate: e.target.value
									})
								}
								// min={new Date().toISOString().split('T')[0]}
							/>
						</div>
					</div>
					<div className="col-md-6 pr-6">
						<div className={disabledAmendment ? `form-group disabled` : `form-group`}>
							<label htmlFor="salesContructNo">Amendment</label>
							<CustomDropdown
								items={amendmentList}
								onItemClick={(item) => setAmendment(item)}
								selectedItem={amendment?.amendmentNo}
								showAddNewButton={true}
								addNewButtonName="New Amendment"
								onAddNewButtonClick={createNewAmendment}
								isDisabled={!salesContructInfo?.id || disabledAmendment}
							/>
						</div>
					</div>
					<div className="col-md-6 pl-6">
						<div className={disabledAmendment ? `form-group disabled` : `form-group`}>
							<label htmlFor="amendmentDate">Amendment Date</label>

							<input
								type="date"
								value={amendment?.amendmentDate}
								// disabled={disabledAmendment}
								onChange={(e) =>
									setAmendment({
										...amendment,
										amendmentDate: e.target.value
									})
								}
							/>
						</div>
					</div>
				</div>
			</div>
		</LoaderComponent>
	);
};

export default EditSalesContruct;
